/* Tayob Scientific navigation trail
   Remembers the steps a visitor took in this browser tab (Home > Search or Collection) and
   shows them as the breadcrumb on product pages, plus a Back link that matches. */
(function () {
  var KEY = 'tayobTrail';
  var LEVEL = { home: 0, shop: 1, collection: 2, search: 2, product: 3 };

  function load() {
    try {
      var t = JSON.parse(sessionStorage.getItem(KEY) || '[]');
      return Array.isArray(t) ? t : [];
    } catch (e) {
      return [];
    }
  }

  function save(t) {
    try { sessionStorage.setItem(KEY, JSON.stringify(t)); } catch (e) {}
  }

  function short(text, n) {
    text = String(text || '');
    return text.length > n ? text.slice(0, n - 1) + '…' : text;
  }

  function currentMeta() {
    var el = document.getElementById('TayobPageMeta');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init() {
    var meta = currentMeta();
    if (!meta || !(meta.type in LEVEL)) return;

    var trail = load();

    if (meta.type !== 'product') {
      var label = meta.label;
      if (meta.type === 'search') label = meta.label ? 'Search: “' + short(meta.label, 28) + '”' : 'Search';
      if (meta.type === 'home') {
        trail = [];
      }
      var lvl = LEVEL[meta.type];
      trail = trail.filter(function (e) { return LEVEL[e.type] < lvl; });
      trail.push({
        type: meta.type,
        label: label,
        url: meta.type === 'home' ? '/' : location.pathname + location.search
      });
      save(trail);
      return;
    }

    renderProduct(meta, trail);
  }

  function crumbItem(label, url) {
    var li = document.createElement('li');
    if (url) {
      var a = document.createElement('a');
      a.href = url;
      a.textContent = label;
      li.appendChild(a);
    } else {
      var s = document.createElement('span');
      s.setAttribute('aria-current', 'page');
      s.textContent = label;
      li.appendChild(s);
    }
    return li;
  }

  function renderProduct(meta, trail) {
    var nav = document.querySelector('.tayob-crumbs');
    if (!nav) return;
    var list = nav.querySelector('.tayob-crumbs__list');
    var back = nav.querySelector('[data-tayob-back]');

    // Only use the visitor's own path if it contains a real step (shop, collection or search).
    var steps = trail.filter(function (e) { return LEVEL[e.type] >= 1; });
    if (steps.length) {
      var items = [{ type: 'home', label: 'Home', url: '/' }];
      var hasShop = steps.some(function (e) { return e.type === 'shop'; });
      var first = steps[0];
      if (first.type === 'collection' && !hasShop) items.push({ type: 'shop', label: 'Shop', url: '/collections' });
      items = items.concat(steps);

      if (list) {
        list.innerHTML = '';
        items.forEach(function (e) { list.appendChild(crumbItem(e.label, e.url)); });
        list.appendChild(crumbItem(meta.label, null));
      }

      var last = steps[steps.length - 1];
      if (back) {
        back.setAttribute('href', last.url);
        var text = 'Back to ' + last.label;
        if (last.type === 'search') text = 'Back to search results';
        if (last.type === 'shop') text = 'Back to Shop';
        var span = back.querySelector('[data-back-label]');
        if (span) span.textContent = text;
      }
    }

    // Use real browser history when the visitor came from another page of the shop, so
    // scroll position and filters are kept.
    if (!back) return;
    var ref = null;
    try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) { ref = null; }
    var sameShop = ref && ref.origin === location.origin && ref.pathname !== location.pathname;
    var usable = sameShop && !/^\/(cart|checkout|account|customer_authentication|pages\/quote)/.test(ref.pathname);
    if (!usable) return;
    back.addEventListener('click', function (e) {
      if (history.length > 1) {
        e.preventDefault();
        history.back();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
